import { useInspectorStore } from '../../stores/inspectorStore';
import styled from 'styled-components';
import { useActiveGuide, useActivePage } from '../../queries/guides';
import {
  BackButton,
  SwitchPreviewModeButton,
  ToggleAudiencesModalButton,
  ToggleInspectorPanelButton,
} from '../guides/Header';
import { useGuideStore } from '../../stores/guideStore';
import { isDevelopment } from '../../constants/app';
import { token } from '@bynder/design-system';
import { VISUALS } from '../../constants/styles';
import { GuideType } from '../../types';
import React from 'react';

export const SinglePageHeader: React.FC<{
  isHeaderHidden: boolean;
  guideGroupId: string | null;
  guideId: string;
  showPreviewModeButton?: boolean;
}> = ({ isHeaderHidden, guideGroupId, guideId, showPreviewModeButton = true }) => {
  const isInspectorOpen = useInspectorStore(s => s.isInspectorOpen);
  const { data: activeGuide } = useActiveGuide();
  const { data: activePage } = useActivePage();
  const isEditMode = useGuideStore(s => s.isEditMode);
  const isHomepage = activeGuide?.type === GuideType.HOME_PAGE;
  const isSidebarOpen = isEditMode && isHomepage && activeGuide?.targetedPagesEnabled;
  const isAudiencesEnabled = activeGuide?.targetedPagesEnabled;
  const shouldShowAudiences  = isAudiencesEnabled && isHomepage && isEditMode && activeGuide?.chapters?.[0]?.pages?.length > 1;

  return (
    activePage?.canEdit && (
      <StyledFloatingHeaderContainer $isHeaderHidden={isHeaderHidden}>
        <LeftSide $isSidebarOpen={isSidebarOpen}>
          <BackButton
            guideGroupId={guideGroupId}
            guideId={guideId}
            guideType={GuideType.SINGLE_PAGE}
          />
        </LeftSide>
        <RightSide $isInspectorOpen={isInspectorOpen}>
          {shouldShowAudiences && <ToggleAudiencesModalButton />}
          {isEditMode && <ToggleInspectorPanelButton />}
          {showPreviewModeButton && <SwitchPreviewModeButton />}
        </RightSide>
      </StyledFloatingHeaderContainer>
    )
  );
};

const LeftSide = styled.div<{ $isSidebarOpen?: boolean }>`
  position: relative;
  pointer-events: auto;
  left: ${props => (props.$isSidebarOpen ? VISUALS.SIDEBAR_WIDTH : `0px`)};
`;
const RightSide = styled.div<{ $isInspectorOpen?: boolean }>`
  pointer-events: auto;
  gap: ${token.spacing3};
  display: flex;
  position: absolute;
  right: ${props => (props.$isInspectorOpen ? `350px` : `16px`)};
  transition: right 0.2s ease-in-out;
`;

const StyledFloatingHeaderContainer = styled.header<{
  $isHeaderHidden?: boolean;
}>`
  pointer-events: none;
  width: 100%;
  position: fixed;
  top: ${props => (props.$isHeaderHidden || isDevelopment ? `0px` : `110px`)};
  z-index: 98;
  padding: 0 18px;
  display: flex;
  align-items: center;
  height: 50px;
`;
